module.exports = __webpack_public_path__ + "static/digital_strategy-a042a8d8108c255efa538ca258146ba0.png";